// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__FwnZY"};